import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) nav("/admin", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await login(email, password);
      nav("/admin", { replace: true });
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-transparent border-b border-[#F7F5F0]/25 py-3 font-body text-[#F7F5F0] placeholder-[#F7F5F0]/40 focus:outline-none focus:border-[#C5A880] transition-colors duration-300";

  return (
    <div className="min-h-screen bg-[#062029] grain overflow-hidden grid place-items-center px-6" data-testid="admin-login">
      <div className="w-full max-w-sm">
        <p className="label text-[#C5A880] mb-4">Salvatore Business Gateway</p>
        <h1 className="font-serif-display text-[#F7F5F0] text-4xl mb-10">Admin Access</h1>
        <form onSubmit={submit} className="space-y-6">
          <input className={field} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email" />
          <input className={field} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password" />
          {err && <p className="text-[#e0a0a0] text-sm font-body" data-testid="admin-error">{err}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full border border-[#C5A880]/60 text-[#F7F5F0] py-3 text-[12px] tracking-widest uppercase hover:bg-[#C5A880] hover:text-[#062029] transition-colors duration-500 disabled:opacity-50">
            {loading ? "…" : "Enter"}
          </button>
        </form>
      </div>
    </div>
  );
}
